import Base from './base'

export default {
  get () {
    return Base
      .get(`/threadcolor/all`)
      .then(res => res.data)
  }
}
